import React from 'react';
import PropTypes from 'prop-types';

import {
  TabContainer,
  Tab,
  TabLabel,
  TabIconWrapper,
} from './styles';

const IconTabBar = ({
  tabsConfig, selectedTab, onSelectTab, className,
}) => (
  <TabContainer className={className} role="tablist">
    {Object.entries(tabsConfig).map(([tab, { label, icon: TabIcon }]) => {
      const isActive = selectedTab === tab;
      return (
        <Tab
          key={tab}
          $active={isActive}
          onClick={() => onSelectTab(tab)}
          id={`icon-tab-${tab}`}
          role="tab"
          aria-label={label}
          aria-selected={isActive}
        >
          <TabIconWrapper>
            {TabIcon && <TabIcon />}
          </TabIconWrapper>
          <TabLabel>{label}</TabLabel>
        </Tab>
      );
    })}
  </TabContainer>
);

IconTabBar.propTypes = {
  className: PropTypes.string,
  tabsConfig: PropTypes.object.isRequired,
  selectedTab: PropTypes.string,
  onSelectTab: PropTypes.func,
};

IconTabBar.defaultProps = {
  className: '',
  selectedTab: '',
  onSelectTab: () => {},
};

export default IconTabBar;
